<template>
  <div class="facial-harmonization-container">
    <div class="content-section">
      <h2 class="pb-2 border-bottom">Facial Harmonization</h2>
      <p>Balance, Symmetry, and Natural Results</p>
      <p>
        Our facial harmonization treatments are designed to create balance and
        natural beauty through minimally invasive techniques. Rather than
        focusing on one feature, we take a holistic approach to enhance overall
        harmony and confidence.
      </p>
      <h3>Key Treatments</h3>
      <ul>
        <li>
          Neuromodulators — soften facial expressions for a refreshed look.
        </li>
        <li>
          Dermal Fillers — restore volume and enhance contour in cheeks, lips,
          and jawline.
        </li>
        <li>
          Chin & Jawline Definition — balance proportions for a more structured
          profile.
        </li>
        <li>
          Lip Enhancement — subtle or fuller results, always tailored to your
          preference.
        </li>
        <li>
          Non-Surgical Rhinoplasty — refine nose shape with precise filler
          techniques.
        </li>
        <li>
          Under-Eye & Temple Support — restore volume and smooth appearance.
        </li>
        <li>Cheekbone Lift — create mid-face definition and natural lift.</li>
        <li>
          Skin Boosters (PRP, biostimulatory treatments) — improve hydration and
          skin quality.
        </li>
        <li>PDO Threads (optional) — add lift without invasive surgery.</li>
      </ul>
      <p>
        Combination treatments are planned to create natural, balanced results
        instead of isolated changes.
      </p>
      <h3>Procedure Overview</h3>
      <ul>
        <li>
          Consultation & Analysis — personalized facial assessment and treatment
          planning.
        </li>
        <li>
          Procedure — safe, precise techniques with local anesthesia or numbing
          cream if needed.
        </li>
        <li>Immediate Results — natural improvements with minimal downtime.</li>
        <li>
          Aftercare & Follow-up — clear guidance to support comfort and
          long-lasting outcomes.
        </li>
      </ul>
      <p>
        "Facial harmonization is not about changing who you are — it's about
        enhancing your natural beauty with balance, confidence, and subtle
        refinement."
      </p>
    </div>
    <div class="fh-videos">
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
          margin-bottom: 1.5rem;
        "
        src="https://www.youtube.com/embed/dsy8tUMNyIs"
        title="YouTube Shorts: Facial Harmonization 1"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        "
        src="https://www.youtube.com/embed/LM2IEIQ-mC8"
        title="YouTube Shorts: Facial Harmonization 2"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "FacialHarmonizationContentEn",
};
</script>

<style scoped>
.facial-harmonization-container {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.content-section {
  flex: 1;
  min-width: 0;
}

.fh-videos {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.fh-videos iframe {
  width: 320px;
  height: 568px;
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* Responsive design */
@media (max-width: 768px) {
  .facial-harmonization-container {
    flex-direction: column;
    gap: 1.5rem;
  }

  .fh-videos {
    align-self: center;
  }

  .fh-videos iframe {
    width: 280px;
    height: 497px;
  }
}

@media (max-width: 480px) {
  .fh-videos iframe {
    width: 240px;
    height: 426px;
  }
}
</style>
